import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { generatePath, useLocation, useNavigate } from 'react-router-dom';
import { DataHubService } from 'src/core/services/datahub';
import { ClickContentCreatePageSchema } from 'src/core/services/datahub/schemas/moduleList/clickContentCreatePageSchema';
import { PageTypeIcon } from 'src/modules/contentList/components/pageTypeIcon/pageTypeIcon';
import { Dropdown } from 'src/shared/components/dropdown';
import { Routes } from 'src/shared/constants/routes';
import { useLayout } from 'src/shared/hooks/useLayout';
function renderPageTypeIcon(pageType) {
    return (_jsx(PageTypeIcon, { pageType: pageType, className: clsx('h-[28px] w-[28px] rounded-medium md:h-[40px] md:w-[40px] md:rounded-extralarge') }));
}
export function AddPageMenuItems({ moduleId, className }) {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const location = useLocation();
    const { isMobile } = useLayout();
    function getPageTypeUrl(pageType) {
        return generatePath(Routes.ManagePage, { moduleId, pageType, pageId: 'new' });
    }
    function handleNavigateToCreateNewPage(pageType) {
        navigate({ pathname: getPageTypeUrl(pageType), search: location.search });
        DataHubService.sendEvent({
            schema: new ClickContentCreatePageSchema({
                pageType
            })
        });
    }
    return (_jsxs(_Fragment, { children: [_jsx(Dropdown.Item, { title: t('page_types.lesson'), className: className, icon: renderPageTypeIcon('content'), onClick: () => handleNavigateToCreateNewPage('content'), ...(!isMobile && { description: t('content_list.module_card.create_content') }) }), _jsx(Dropdown.Item, { className: className, title: t('page_types.quiz'), icon: renderPageTypeIcon('quiz'), onClick: () => handleNavigateToCreateNewPage('quiz'), ...(!isMobile && { description: t('content_list.module_card.create_quiz') }) }), _jsx(Dropdown.Item, { className: className, title: t('page_types.advertisement'), icon: renderPageTypeIcon('advertisement'), onClick: () => handleNavigateToCreateNewPage('advertisement'), ...(!isMobile && { description: t('content_list.module_card.create_ad') }) }), _jsx(Dropdown.Item, { className: className, title: t('page_types.live'), icon: renderPageTypeIcon('webinar'), onClick: () => handleNavigateToCreateNewPage('webinar'), ...(!isMobile && { description: t('content_list.module_card.create_live') }) })] }));
}
